export default {
    setAllExperts (state, { experts }) {
        state.experts = experts
    },
    setExpert (state, { expert }) {
        state.expert = expert
    },
    setExpertVideos (state, { expertVideos }) {
        state.expertVideos = expertVideos
    },
    setComingVideoFlag (state, videosFlag) {
        state.videosComingSoonFlag = videosFlag
    },
    setExpertPlaylist (state, {playList}) {
        state.expertPlaylist = playList
    },
    setExpertArchiveClips (state, {clips}) {
        state.expertArchiveClips = clips
    },
    setExpertNextEvent (state, {event}) {
        state.expertNextEvent = event
    }
}



// WEBPACK FOOTER //
// ./src/store/experts/mutations.js